<div id="student-strength" class="inner-page">
  <div class="mou-container">

    <h2 class="title">Student Strength</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa maintains a robust student community across multiple disciplines. 
      Below is the detailed list of admitted students and course-wise enrollment strength for the academic session 2025–26.
    </p>

    <hr class="divider">

    <div class="mou-table-container">
      <table class="mou-table">
        <thead>
          <tr class="year-header">
            <th colspan="3">Admitted Students Detail 2025-26</th>
          </tr>
          <tr class="column-header">
            <th style="width: 12%; text-align: center;">Sr. No.</th>
            <th style="width: 63%;">Classes</th>
            <th style="width: 25%; text-align: center;">Strength</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">1</td>
            <td>B.A I</td>
            <td style="text-align: center; font-weight: 600;">135</td>
          </tr>
          <tr>
            <td style="text-align: center;">2</td>
            <td>B.A II</td>
            <td style="text-align: center; font-weight: 600;">137</td>
          </tr>
          <tr>
            <td style="text-align: center;">3</td>
            <td>B.A III</td>
            <td style="text-align: center; font-weight: 600;">149</td>
          </tr>
          <tr>
            <td style="text-align: center;">4</td>
            <td>B.COM I</td>
            <td style="text-align: center; font-weight: 600;">46</td>
          </tr>
          <tr>
            <td style="text-align: center;">5</td>
            <td>B.Com Gen. II</td>
            <td style="text-align: center; font-weight: 600;">31</td>
          </tr>
          <tr>
            <td style="text-align: center;">6</td>
            <td>B.Com Gen. III</td>
            <td style="text-align: center; font-weight: 600;">18</td>
          </tr>
          <tr>
            <td style="text-align: center;">7</td>
            <td>B.Com Voc. III</td>
            <td style="text-align: center; font-weight: 600;">13</td>
          </tr>
          <tr>
            <td style="text-align: center;">8</td>
            <td>B.SC. PHYSICAL SC. I</td>
            <td style="text-align: center; font-weight: 600;">47</td>
          </tr>
          <tr>
            <td style="text-align: center;">9</td>
            <td>B.Sc PHYSICAL SC. II</td>
            <td style="text-align: center; font-weight: 600;">22</td>
          </tr>
          <tr>
            <td style="text-align: center;">10</td>
            <td>B.Sc NM III</td>
            <td style="text-align: center; font-weight: 600;">18</td>
          </tr>
          <tr>
            <td style="text-align: center;">11</td>
            <td>B.Sc CS III</td>
            <td style="text-align: center; font-weight: 600;">12</td>
          </tr>
          <tr>
            <td style="text-align: center;">12</td>
            <td>B.Sc. PHYSICAL,HEALTH & SPORTS I</td>
            <td style="text-align: center; font-weight: 600;">23</td>
          </tr>
          <tr>
            <td style="text-align: center;">13</td>
            <td>BAJMC I</td>
            <td style="text-align: center; font-weight: 600;">26</td>
          </tr>
          <tr>
            <td style="text-align: center;">14</td>
            <td>BAJMC II</td>
            <td style="text-align: center; font-weight: 600;">22</td>
          </tr>
          <tr>
            <td style="text-align: center;">15</td>
            <td>BAJMC III</td>
            <td style="text-align: center; font-weight: 600;">29</td>
          </tr>
          <tr>
            <td style="text-align: center;">16</td>
            <td>BPED I</td>
            <td style="text-align: center; font-weight: 600;">45</td>
          </tr>
          <tr>
            <td style="text-align: center;">17</td>
            <td>BPED II</td>
            <td style="text-align: center; font-weight: 600;">49</td>
          </tr>
          <tr>
            <td style="text-align: center;">18</td>
            <td>BBA I</td>
            <td style="text-align: center; font-weight: 600;">30</td>
          </tr>
          <tr>
            <td style="text-align: center;">19</td>
            <td>BBA II</td>
            <td style="text-align: center; font-weight: 600;">29</td>
          </tr>
          <tr>
            <td style="text-align: center;">20</td>
            <td>BBA III</td>
            <td style="text-align: center; font-weight: 600;">20</td>
          </tr>
          <tr>
            <td style="text-align: center;">21</td>
            <td>BCA I</td>
            <td style="text-align: center; font-weight: 600;">31</td>
          </tr>
          <tr>
            <td style="text-align: center;">22</td>
            <td>BCA II</td>
            <td style="text-align: center; font-weight: 600;">45</td>
          </tr>
          <tr>
            <td style="text-align: center;">23</td>
            <td>BCA III</td>
            <td style="text-align: center; font-weight: 600;">38</td>
          </tr>
          <tr>
            <td style="text-align: center;">24</td>
            <td>DPED I</td>
            <td style="text-align: center; font-weight: 600;">50</td>
          </tr>
          <tr>
            <td style="text-align: center;">25</td>
            <td>DPED II</td>
            <td style="text-align: center; font-weight: 600;">50</td>
          </tr>
          <tr>
            <td style="text-align: center;">26</td>
            <td>M.A Hindi I</td>
            <td style="text-align: center; font-weight: 600;">21</td>
          </tr>
          <tr>
            <td style="text-align: center;">27</td>
            <td>M.A Hindi II</td>
            <td style="text-align: center; font-weight: 600;">14</td>
          </tr>
          <tr>
            <td style="text-align: center;">28</td>
            <td>M.Com I</td>
            <td style="text-align: center; font-weight: 600;">16</td>
          </tr>
          <tr>
            <td style="text-align: center;">29</td>
            <td>M.Com II</td>
            <td style="text-align: center; font-weight: 600;">13</td>
          </tr>
          <tr>
            <td style="text-align: center;">30</td>
            <td>M.Sc Mathematics I</td>
            <td style="text-align: center; font-weight: 600;">14</td>
          </tr>
          <tr>
            <td style="text-align: center;">31</td>
            <td>M.Sc Mathematics II</td>
            <td style="text-align: center; font-weight: 600;">11</td>
          </tr>
          <tr>
            <td style="text-align: center;">32</td>
            <td>M.A English I</td>
            <td style="text-align: center; font-weight: 600;">18</td>
          </tr>
          <tr>
            <td style="text-align: center;">33</td>
            <td>M.A English II</td>
            <td style="text-align: center; font-weight: 600;">19</td>
          </tr>
          <tr>
            <td style="text-align: center;">34</td>
            <td>M.A Pub. Ad. I</td>
            <td style="text-align: center; font-weight: 600;">23</td>
          </tr>
          <tr>
            <td style="text-align: center;">35</td>
            <td>M.A Pub. Ad. II</td>
            <td style="text-align: center; font-weight: 600;">17</td>
          </tr>
          <tr class="total-row">
            <td colspan="2" style="text-align: right; padding-right: 30px;">Total</td>
            <td style="text-align: center; font-size: 16px; color: var(--primary);">1281</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
